module.exports = __webpack_public_path__ + "static/media/volunteer1.287cfc9d.jpg";